/**
 * web买家场景通用打点库, 从ncms那rax那迁移过来
 */

// 判断goldkey是否正确
const checklogKey = (logkey) => {
  if (logkey.indexOf('/') !== 0) {
    return false;
  }
  return true;
};
// 清空打点串字符特殊字符
export const checkLogString = (value)  => {
  const reg = /[&=\s]/g;
  if (reg.test(value)) {
    console.warn && console.warn(`打点业务串 ${value} 中不允许含有保留字符 &=`);
    return value.replace(reg, '');
  }
  return value;
};

export const getLogParamsString = (options) => {
  return Object.keys(options).map((item) => {
    let value = options[item];
    if (value === undefined) {
      value = '';
    }
    value = checkLogString(value.toString());
    return `${item}=${value}`;
  }).join('&');
};

export const dot = (logKey, type = 'CLK', options) => {
  if (!checklogKey(logKey)) {
    throw new Error('打点的黄金令箭不正确, 以/开头');
  }

  const reg = /[^\d_a-zA-Z@\-%]/g;


  // floorName检查，不允许其它特殊字符，空格
  // @字符用来区分一级tab信息或者tab信息
  // -有特定用途作为分割符
  if (options.floorName) {
    options.floorName = options.floorName.replace(reg, '');
  }

  if (!options.floorName && logKey.indexOf('.nav_') === -1) {
    // eslint-disable-next-line
    console.warn && console.warn('floorName不合法，打点floorName特殊字符已过滤，只允许/[^\\d_a-zA-Z@\\-%]/g, 文档：https://yuque.antfin-inc.com/ncms/oxxyex/kib0mw');
  }


  const dotObj = getLogParamsString(options);

  if (window.goldlog) {
    window.goldlog.record(logKey, type, dotObj, 'GET');
  } else {
    window.goldlog_queue = window.goldlog_queue || [];
    window.goldlog_queue.push({
      action: 'goldlog.record',
      arguments: [logKey, type, dotObj, 'GET'],
    });
  }
};


// 通用arms,retcode打点方法
export const retcode = (type, args) => {
  if (window.__bl && window.__bl[type]) {
    window.__bl && window.__bl[type](...args);
  } else {
    window.__bl = window.__bl || {};
    window.__bl.pipe = window.__bl.pipe || [];
    window.__bl.pipe.push([type, ...args]);
  }
};

/*
 * 每个业务场景的点击都有统一的黄金令箭 后缀业务标识，前缀是可以修改的
 * 如商品曝光：/sc.mobile.intelligent.product_clk
 * 令箭前缀为：/sc.mobile.intelligent.
 * 令箭后缀为：product_clk
 */

const keypre = '/sc.mobile.intelligent.';

// 导航曝光点击
export const dotTabExp = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre}nav_exp`, 'EXP', argObj.params);
};
// 导航tab点击
export const dotTab = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre}nav_clk`, 'CLK', argObj.params);
};


// 商品点击
export const dotProduct = (argObj) => {
  retcode('sum', ['l-d', 1]);
  dot(argObj.gokey ? argObj.gokey : `${keypre}product_clk`, 'CLK', argObj.params);
};
// 商品曝光
export const dotProductExp = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre}product_exp`, 'EXP', argObj.params);
};

// 商家点击
export const dotSupplier = (argObj) => {
  retcode('sum', ['l-d', 1]);
  dot(argObj.gokey ? argObj.gokey : `${keypre}supplier_clk`, 'CLK', argObj.params);
};

// 商家曝光
export const dotSupplierExp = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre}supplier_clk`, 'EXP', argObj.params);
};

// 场景入口点击
export const dotEntrance = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre}entrance_clk`, 'CLK', argObj.params);
};

// 场景入口曝光
export const dotEntranceExp = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre} entrance_exp`, 'EXP', argObj.params);
};

// 自定义点击
export const dotCustom = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre}custom_clk`, 'CLK', argObj.params);
};
// 自定义爆光
export const dotCustomExp = (argObj) => {
  dot(argObj.gokey ? argObj.gokey : `${keypre}custom_exp`, 'EXP', argObj.params);
};



// 仅web下才支持通过event取spmc
export const getFloorDotInfo = (event) => {
  let spmc = '';
  let moduleName = '';
  let moduleVersion = '';

  // ios下没有event.path;
  const getElementAttr = (dom) => {
    if (dom && dom.attributes && dom.attributes['data-spm']) {
      spmc = dom.attributes['data-spm'].value;
      if (dom.attributes['data-modulename']) {
        moduleName = dom.attributes['data-modulename'].value || '';
      }
      if (dom.attributes['data-moduleversion']) {
        moduleVersion = dom.attributes['data-moduleversion'].value || '';
      }
    } else if (dom.tagName !== 'BODY') {
      getElementAttr(dom.parentElement);
    }
  };
  getElementAttr(event.srcElement);
  return {
    spmc,
    moduleName,
    moduleVersion,
  };
};


// 个性化导航打点统一参数处理
export function setNavDotParams(params) {
  const reg = /[^\d_a-zA-Z\-%]/g;
  // navNames检查，不允许其它特殊字符，空格

  if (params.navNames) {
    if (typeof params.navNames === 'object') {
      params.navNames = params.navNames.map((v) => {
        return encodeURIComponent(v.toString()).replace(reg, '');
      });
      params.navNames = params.navNames.join('#');
    } else if (typeof params.navNames === 'string') {
      params.navNames = params.navNames.replace(',', '#');
    }
  }
  if (params.parentNavName) {
    params.parentNavName = encodeURIComponent(params.parentNavName).replace(reg, '');
  }
  return params;
}

export function p4pdot(_url, floorName) {
  let url = _url;
  if (!url) {
    return;
  }
  const now = Date.now();
  const n = `p4plog_${now}`;
  if (url.indexOf('?') === -1) {
    url = `${url}?_log_t=${n}`;
  } else {
    url = `${url}&_log_t=${n}`;
  }
  const img = new Image();
  window[n] = img;
  const loadAfter = () => {
    try {
      delete window[n];
    } catch (err) {
      window[n] = null;
    }
    img.onload = null;
  };

  img.onload = () => {
    loadAfter();
  };

  img.onerror = () => {
    loadAfter();
  };

  img.src = url;

  dot('/sc.p4p.click', 'CLK', {
    floorName: floorName || 'p4p_click_2019_1111',
    page_url: encodeURIComponent(window.location.href),
    eurl: encodeURIComponent(url),
    log_time: now,
  });
}

// 暴露全局p4p打点方法
window.__p4pdot = p4pdot;